<div class="full-screen-dialog branch-details">
  <button class="floating-close-button" [mat-dialog-close]>
    <svg-icon-sprite style="color:white;" [src]="'assets/images/svgIconsSprite.svg#cross'" [width]="'24px'">
    </svg-icon-sprite>
  </button>
  <h1 mat-dialog-title>{{data.title}}</h1>
  <mat-dialog-content class="scrollable-container">
    <table class="table" mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef style="width:40%;"> Name </th>
        <td mat-cell *matCellDef="let element">
          {{element.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> Id </th>
        <td mat-cell *matCellDef="let element">
          {{data.journey_hash}}{{element.id}}
          <i (click)="copyText('' + data.journey_hash + element.id)" class="copy material-icons"
            title="Copy">file_copy</i>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"></tr>
    </table>
  </mat-dialog-content>
</div>
